import React from 'react';
import { Formik, Form } from 'formik';
import { sendContactForm } from '../utils/contactService';
import * as Yup from 'yup';
import Input from '../components/Input';

const schema = Yup.object().shape({
    name: Yup.string().required('Моля, въведете вашето име.'),
    email: Yup.string()
        .email('Невалиден имейл.')
        .required('Моля, въведете вашия email адрес.'),
    phone: Yup.string().required('Моля, въведете вашия телефонен номер.'),
});

function ContactForm({
    className = 'flex flex-col items-start w-full md:mx-auto',
    formName,
    formRef,
}) {
    return (
        <div className="w-full">
            <Formik
                initialValues={{ name: '', phone: '', email: '', message: '' }}
                validationSchema={schema}
                onSubmit={(values, actions) => {
                    values.formName = formName;
                    sendContactForm(values)
                        .then(() => {
                            actions.resetForm();
                        })
                        .catch((err) => {})
                        .finally(() => actions.setSubmitting(false));
                }}>
                {({ isSubmitting, errors, touched }) => (
                    <Form
                        name={formName}
                        netlify="true"
                        data-netlify={true}
                        className={`${className} gap-2`}>
                        {errors.name && touched.name ? (
                            <p
                                className="text-sm text-red-400 mt-1"
                                name="name"
                                component="div">
                                {errors.name}
                            </p>
                        ) : null}
                        {errors.email && touched.email ? (
                            <p
                                className="text-sm text-red-400 mt-1"
                                name="email"
                                component="div">
                                {errors.email}
                            </p>
                        ) : null}
                        {errors.phone && touched.phone ? (
                            <p
                                className="text-sm text-red-400 mt-1"
                                name="phone"
                                component="div">
                                {errors.phone}
                            </p>
                        ) : null}
                        <Input
                            type="hidden"
                            name="bot-field"
                        />
                        <div className="flex flex-col gap-4 w-full lg:flex-row">
                            <div className="flex flex-col w-full lg:w-1/2 items-start">
                                <label className="text-lg font-bold">
                                    Име
                                </label>
                                <Input
                                    type="text"
                                    name="name"
                                    placeholder="Вашето име"
                                    autocomplete="off"
                                />
                            </div>
                            <div className="flex flex-col w-full lg:w-1/2 items-start">
                                <label className="text-lg font-bold">
                                    Телефон
                                </label>
                                <Input
                                    type="email"
                                    name="email"
                                    placeholder="Имейл"
                                />
                            </div>
                        </div>
                        <label className="text-lg mt-2 font-bold">
                            Имейл адрес
                        </label>
                        <Input
                            type="text"
                            name="phone"
                            placeholder="Телефон"
                        />
                        <label className="text-lg mt-2 font-bold">
                            Съобщение
                        </label>
                        <Input
                            type="text"
                            component="textarea"
                            name="message"
                            placeholder="Съобщение"
                        />
                        <button
                            className="text-white mt-2 border-brand bg-brand hover:bg-white hover:text-brand py-3 outline-none px-12 border-2 text-base cursor-pointer rounded-full font-normal transition-all duration-200"
                            type="submit"
                            disabled={isSubmitting}>
                            Изпрати съобщение
                        </button>
                    </Form>
                )}
            </Formik>
        </div>
    );
}

export default ContactForm;
